import { ExecutionEnvModes } from "@constants/enums";
import { FilterType } from "./types";

export const filterItems: FilterType[] = [
	{
		value: "all",
		label: "All",
	},
	{
		value: "browser",
		label: "Browser",
	},
	{
		value: "workflow",
		label: "Workflow",
	},
];

export enum QueryType {
	RULE = "RULE",
	RESDSQL = "RESDSQL"
};


export const getWorkflowPayload = (database_name: string, query: string, isDatabricks?: boolean) => {
	const rdbms = {
		"id": "10e1557f-1baa-435d-96fe-4d704457a0ea",
		"fn_id": "ReadRDBMS",
		"fnName": "read.read_from_rdbms",
		"title": "Read RDBMS",
		"inputPorts": [],
		"outputPorts": [
		  {
			"id": "c4425a16-ad84-4b8e-af21-dd342ee8610d",
			"type": "OUT-0",
			"link": [
			  "30682bc5-2d83-4b2f-b77b-b9fb15e52e6d"
			],
			"parentNode": "10e1557f-1baa-435d-96fe-4d704457a0ea"
		  }
		],
		"data": [
		  {
			"key": "connection_name",
			"value": database_name,
			"arg_index": 2,
			"variable_type": "string",
			"useKey": true
		  },
		  {
			"key": "p_type",
			"value": "Query",
			"arg_index": 3,
			"variable_type": "string",
			"useKey": true
		  },
		  {
			"key": "p_query",
			"value": query,
			"arg_index": 5,
			"remove_multiline": true,
			"variable_type": "string",
			"useKey": true
		  },
		  {
			"key": "p_partition",
			"value": "",
			"arg_index": 6,
			"variable_type": "string",
			"useKey": true
		  },
		  {
			"key": "p_fetchsize",
			"value": 50000,
			"arg_index": 10,
			"variable_type": "integer",
			"useKey": true
		  },
		  {
			"key": "sqlContext",
			"value": "sqlContext",
			"variable_type": "",
			"arg_index": 1
		  },
		  {
			"key": "p_table",
			"value": "",
			"arg_index": 4,
			"variable_type": "string",
			"useKey": true
		  },
		  {
			"key": "p_numpartitions",
			"value": 1,
			"arg_index": 7,
			"variable_type": "integer",
			"useKey": true
		  },
		  {
			"key": "p_lower",
			"value": 1,
			"arg_index": 8,
			"variable_type": "string",
			"useKey": true
		  },
		  {
			"key": "p_upper",
			"value": 1,
			"arg_index": 9,
			"variable_type": "string",
			"useKey": true
		  }
		],
		"type": "component",
		"df_name": "read_rdbms_0",
		"previewAllowed": true,
		"field_workflow_config_mapping": {},
		"field_var_mapping": [],
		"extraData": {}
	};
	const sql = {
		"id": "10e1557f-1baa-435d-96fe-4d704457a0ea",
		"fn_id": "sql_query",
		"fnName": "transform.sql_query",
		"title": "SQL Query",
		"inputPorts": [
			{
				"id": "2dc565e9-15cb-4145-a6fe-e9da3d8a5528",
				"type": "IN-0",
				"link": [],
				"parentNode": "6a6d9eef-f90a-4c31-a5cc-085a13eb9155"
			}
		],
		"outputPorts": [
			{
			  "id": "c4425a16-ad84-4b8e-af21-dd342ee8610d",
			  "type": "OUT-0",
			  "link": [
				"30682bc5-2d83-4b2f-b77b-b9fb15e52e6d"
			  ],
			  "parentNode": "10e1557f-1baa-435d-96fe-4d704457a0ea"
			}
		],
		"data": [
			{
				"key": "Query",
				"value": query,
				"arg_index": 2,
				"remove_multiline": true,
				"variable_type": "string"
			},
			{
				"key": "sqlContext",
				"value": "sqlContext",
				"variable_type": "",
				"arg_index": 1
			}
		],
		"type": "component",
		"df_name": "sql_query_2",
		"previewAllowed": true,
		"field_workflow_config_mapping": {},
		"field_var_mapping": [],
		"extraData": {},
		"append": true
	};
	const obj = {
		"workflow_config": {},
		"nodes": [
			isDatabricks? sql : rdbms,
		  {
			"id": "eeb14611-f563-46af-ad92-ba52569aab9c",
			"fn_id": "Show",
			"fnName": "write.show_df",
			"title": "Show",
			"inputPorts": [
			  {
				"id": "00f8506a-77b8-40e1-9aca-ef37b8866deb",
				"type": "IN-0",
				"link": [
				  "30682bc5-2d83-4b2f-b77b-b9fb15e52e6d"
				],
				"parentNode": "eeb14611-f563-46af-ad92-ba52569aab9c"
			  }
			],
			"outputPorts": [],
			"data": [
			  {
				"key": "schema",
				"value": true,
				"arg_index": 1,
				"variable_type": "boolean"
			  },
			  {
				"key": "records",
				"value": true,
				"arg_index": 2,
				"variable_type": "boolean"
			  },
			  {
				"key": "num_rows",
				"value": "20",
				"arg_index": 3,
				"variable_type": "int"
			  },
			  {
				"key": "truncate",
				"value": true,
				"arg_index": 4,
				"variable_type": "boolean"
			  }
			],
			"type": "component",
			"df_name": "show_6",
			"previewAllowed": true,
			"field_workflow_config_mapping": {}
		  }
		],
		"links": [
		  {
			"id": "30682bc5-2d83-4b2f-b77b-b9fb15e52e6d",
			"bridge": "Read RDBMS  <===>  Show",
			"source": {
			  "node": "10e1557f-1baa-435d-96fe-4d704457a0ea",
			  "port": "OUT-0"
			},
			"target": {
			  "node": "eeb14611-f563-46af-ad92-ba52569aab9c",
			  "port": "IN-0"
			}
		  }
		]
	}
	return JSON.stringify(obj);
};

export const getWorkflowDetails = (database_name: string, query: string, isDatabricks?: boolean) => {
	const rdbms = {
		"id": "10e1557f-1baa-435d-96fe-4d704457a0ea",
		"locked": false,
		"type": "DS",
		"selected": false,
		"extras": {
		  "key": "ReadRDBMS",
		  "fnName": "read.read_from_rdbms",
		  "iconCls": "icon-class",
		  "subheader": [
			{
			  "field": "database",
			  "property": "name"
			},
			{
			  "field": "table",
			  "property": "value"
			}
		  ],
		  "portManagement": {
			"inputPorts": {
			  "defaultValue": 0
			},
			"outputPorts": {
			  "defaultValue": 1
			}
		  },
		  "formData": [
			{
			  "key": "connection_name",
			  "type": "select",
			  "async": {
				"type": "GET",
				"url": "/databrowser/api/v1/datasource?connection_type=RDBMS",
				"init": true,
				"output": "url,username,password,driver,databaseName,name",
				"labelKey": "name",
				"valueKey": "id",
				"ignore_prefix_url": true
			  },
			  "templateOptions": {
				"variable_type": "number",
				"required": true,
				"label": "Select a Database",
				"arg_index": 2,
				"qtip": "Select name of the database",
				"valueProp": "id",
				"labelProp": "name",
				"options": [],
				"useKey": true
			  },
			  "value": database_name,
			  "isFieldHidden": false
			},
			{
			  "key": "p_type",
			  "type": "select",
			  "defaultValue": "Table",
			  "templateOptions": {
				"label": "Table/Query",
				"arg_index": 3,
				"qtip": "Ingest data from a table or write custom SQL query",
				"variable_type": "string",
				"options": [
				  {
					"label": "Table",
					"value": "Table"
				  },
				  {
					"label": "Query",
					"value": "Query"
				  }
				],
				"useKey": true
			  },
			  "value": "Query",
			  "isFieldHidden": false
			},
			{
			  "key": "p_table",
			  "type": "ng-select",
			  "async": {
				"type": "GET",
				"url": "/databrowser/api/v1/datasource//tables?pattern=",
				"ignore_prefix_url": true,
				"triggerField": "values.connection_name",
				"searchable": true,
				"patternProperty": "pattern",
				"output": "label",
				"labelKey": "label",
				"valueKey": "label"
			  },
			  "templateOptions": {
				"variable_type": "string",
				"required": true,
				"label": "Select a Table",
				"arg_index": 4,
				"qtip": "Select table from the specified database",
				"options": [],
				"useKey": true
			  },
			  "hideExpression": "values.p_type === 'Query'",
			  "value": "",
			  "isFieldHidden": true
			},
			{
			  "key": "p_query",
			  "type": "textarea",
			  "editor": true,
			  "templateOptions": {
				"advance_sql": false,
				"variable_type": "string",
				"remove_multiline": true,
				"required": true,
				"useKey": true,
				"qtip": "SQL query to select records from one or more tables",
				"label": "Query",
				"rows": 5,
				"arg_index": 5
			  },
			  "hideExpression": "values.p_type === 'Table'",
			  "value": query,
			  "isFieldHidden": false
			},
			{
			  "key": "p_partition",
			  "type": "select",
			  "async": {
				"type": "GET",
				"url": "/databrowser/api/v1/datasource//table//columns",
				"ignore_prefix_url": true,
				"triggerField": "values.p_table",
				"output": "label",
				"labelKey": "name",
				"valueKey": "name"
			  },
			  "templateOptions": {
				"variable_type": "string",
				"label": "Column to Partition By",
				"useKey": true,
				"qtip": "Select column to partition by while reading from the table",
				"options": [],
				"arg_index": 6
			  },
			  "hideExpression": "values.p_type === 'Query'",
			  "value": "",
			  "isFieldHidden": true
			},
			{
			  "key": "p_partition",
			  "type": "input",
			  "templateOptions": {
				"variable_type": "string",
				"label": "Column to Partition By",
				"useKey": true,
				"qtip": "Select column to partition by while reading from the table.The data type of partitioning column needs to be NUMERIC, DATE or TIMESTAMP",
				"options": [],
				"arg_index": 6
			  },
			  "hideExpression": "values.p_type === 'Table'",
			  "value": "",
			  "isFieldHidden": false
			},
			{
			  "key": "p_numpartitions",
			  "type": "input",
			  "defaultValue": 1,
			  "templateOptions": {
				"variable_type": "integer",
				"useKey": true,
				"label": "Number of Partitions",
				"qtip": "The maximum number of partitions that should be used for parallelization while reading the table",
				"max": 15,
				"min": 1,
				"arg_index": 7
			  },
			  "hideExpression": "values.p_partition === ''",
			  "value": 1,
			  "isFieldHidden": true
			},
			{
			  "key": "p_lower",
			  "type": "input",
			  "defaultValue": 1,
			  "templateOptions": {
				"variable_type": "string",
				"useKey": true,
				"qtip": "Minimum value of the partitioned column.The lower bound can accept INT, DATE or Timestamp values",
				"label": "Lower Bound",
				"arg_index": 8
			  },
			  "hideExpression": "values.p_partition === ''",
			  "value": 1,
			  "isFieldHidden": true
			},
			{
			  "key": "p_upper",
			  "type": "input",
			  "defaultValue": 1,
			  "templateOptions": {
				"variable_type": "string",
				"useKey": true,
				"qtip": "Maximum value of the partitioned column.The upper bound can accept INT, DATE or Timestamp values",
				"label": "Upper Bound",
				"arg_index": 9
			  },
			  "hideExpression": "values.p_partition === ''",
			  "value": 1,
			  "isFieldHidden": true
			},
			{
			  "key": "p_fetchsize",
			  "type": "input",
			  "defaultValue": 50000,
			  "templateOptions": {
				"variable_type": "integer",
				"useKey": true,
				"label": "Fetch Size",
				"qtip": "Number of rows to fetch per iteration",
				"arg_index": 10
			  },
			  "value": 50000,
			  "isFieldHidden": false
			},
			{
			  "key": "num_ip_ports",
			  "type": "input",
			  "value": 0,
			  "defaultValue": 0,
			  "templateOptions": {
				"label": "",
				"options": []
			  },
			  "hideExpression": "true",
			  "isFieldHidden": true
			},
			{
			  "key": "num_op_ports",
			  "type": "input",
			  "value": 1,
			  "defaultValue": 0,
			  "templateOptions": {
				"label": "",
				"options": []
			  },
			  "hideExpression": "true",
			  "isFieldHidden": true
			}
		  ],
		  "filePath": "/nodes/Data Transformation/Relational Sources/read_rdbms.json",
		  "componentInfo": [
			{
			  "key": "description",
			  "defaultValue": "Read RDBMS ingests data from relational tables. This component can read data from a specific table or execute an SQL query to select data from multiple tables."
			}
		  ],
		  "extraData": {
			"workflow_var_mapping": {
			  "all_fields_list": []
			},
			"workflow_config_mapping": {
			  "selectedConfigKeys": "",
			  "selectedFieldKeys": [],
			  "keyFieldMapping": {}
			},
			"connection_name": {
			  "_value": "${database_name}",
			  "url": "jdbc:mysql://10.2.0.226:3306/appmeta",
			  "username": "root",
			  "password": "",
			  "driver": "com.mysql.jdbc.Driver",
			  "databaseName": "appmeta",
			  "name": "Madan_test"
			},
			"p_table": null
		  },
		  "isReadOnly": false
		},
		"x": 144.93699754296046,
		"y": 361.11084043848956,
		"ports": [
		  {
			"id": "c4425a16-ad84-4b8e-af21-dd342ee8610d",
			"type": "DS",
			"selected": false,
			"x": 353.6563108787655,
			"y": 387.1093944160059,
			"name": "OUT-0",
			"alignment": "right",
			"parentNode": "10e1557f-1baa-435d-96fe-4d704457a0ea",
			"links": [
			  "30682bc5-2d83-4b2f-b77b-b9fb15e52e6d"
			],
			"isVariablePort": false
		  }
		],
		"title": "Read RDBMS",
		"subtitle": "DataTransformation",
		"actualTitle": "Read RDBMS",
		"iconKey": "DataTransformation/RelationalSources",
		"isPropertiesValid": true,
		"notes": "",
		"isPropertiesTouched": true,
		"isPropertiesSavedAtleastOnce": true,
		"nodeType": "component",
		"isMounted": true,
		"dfName": "read_rdbms_0",
		"hash": "4a9c51ae48c2b06b011e91cfb7a2a109",
		"portsInOrder": [],
		"portsOutOrder": [
		  "c4425a16-ad84-4b8e-af21-dd342ee8610d"
		]
	};
	const sql =  {
		"id": "10e1557f-1baa-435d-96fe-4d704457a0ea",
		"locked": false,
		"type": "DS",
		"selected": false,
		"extras": {
			"iconCls": "icon-class",
			"boxType": "filterNode",
			"fnName": "transform.sql_query",
			"append": true,
			"prev": 0,
			"key": "sql_query",
		  "portManagement": {
			"inputPorts": {
			  "defaultValue": 1
			},
			"outputPorts": {
			  "defaultValue": 1
			}
		  },
		  "formData":[
			{
			  "key": "Query",
			  "type": "textarea",
			  "editor": true,
			  "templateOptions": {
				"variable_type": "string",
				"arg_index": 2,
				"required": true,
				"remove_multiline": true,
				"label": "Query",
				"rows": 5,
				"qtip": "Provide the query string to be executed on the input dataframe. Use the Query Builder when in doubt."
			  },
			  "value": query,
			  "isFieldHidden": false
			},
			{
			  "key": "num_ip_ports",
			  "type": "input",
			  "value": 1,
			  "defaultValue": 0,
			  "templateOptions": {
				"label": "",
				"options": []
			  },
			  "hideExpression": "true",
			  "isFieldHidden": true
			},
			{
			  "key": "num_op_ports",
			  "type": "input",
			  "value": 1,
			  "defaultValue": 0,
			  "templateOptions": {
				"label": "",
				"options": []
			  },
			  "hideExpression": "true",
			  "isFieldHidden": true
			}
		  ],
		  "filePath": "/nodes/Data Transformation/Relational Sources/read_rdbms.json",
		  "componentInfo": [
			{
			  "key": "description",
			  "defaultValue": "Read RDBMS ingests data from relational tables. This component can read data from a specific table or execute an SQL query to select data from multiple tables."
			}
		  ],
		  "extraData": {
			"workflow_var_mapping": {
			  "all_fields_list": []
			},
			"workflow_config_mapping": {
			  "selectedConfigKeys": "",
			  "selectedFieldKeys": [],
			  "keyFieldMapping": {}
			},
			"connection_name": {
			  "_value": "${database_name}",
			  "url": "jdbc:mysql://10.2.0.226:3306/appmeta",
			  "username": "root",
			  "password": "",
			  "driver": "com.mysql.jdbc.Driver",
			  "databaseName": "appmeta",
			  "name": "Madan_test"
			},
			"p_table": null
		  },
		  "isReadOnly": false
		},
		"x": 144.93699754296046,
		"y": 361.11084043848956,
		"ports": [
		  {
			"id": "c4425a16-ad84-4b8e-af21-dd342ee8610d",
			"type": "DS",
			"selected": false,
			"x": 353.6563108787655,
			"y": 387.1093944160059,
			"name": "OUT-0",
			"alignment": "right",
			"parentNode": "10e1557f-1baa-435d-96fe-4d704457a0ea",
			"links": [
			  "30682bc5-2d83-4b2f-b77b-b9fb15e52e6d"
			],
			"isVariablePort": false
		  }
		],
		"title": "SQL Query",
		"subtitle": "DataTransformation",
		"actualTitle": "SQL Query",
		"iconKey": "DataTransformation/Transform",
		"isPropertiesValid": true,
		"notes": "",
		"isPropertiesTouched": true,
		"isPropertiesSavedAtleastOnce": true,
		"nodeType": "component",
		"isMounted": true,
		"dfName": "sql_query_2",
		"hash": "314be5e7036d52d1e2d23a21cc79dfd1",
		"portsInOrder": [
			"2dc565e9-15cb-4145-a6fe-e9da3d8a5528"
		],
		"portsOutOrder": [
		  "c4425a16-ad84-4b8e-af21-dd342ee8610d"
		]
	};
	const obj = {
		"id": "c1b85bb8-40bf-4e9d-82b4-a6e61a7c4128",
		"offsetX": 89.77895993885753,
		"offsetY": -67.31308382961022,
		"zoom": 83.45000000000005,
		"gridSize": 0,
		"layers": [
		  {
			"id": "b842ce35-eefa-441e-b6f9-02489f650f33",
			"type": "diagram-links",
			"isSvg": true,
			"transformed": true,
			"models": {
			  "30682bc5-2d83-4b2f-b77b-b9fb15e52e6d": {
				"id": "30682bc5-2d83-4b2f-b77b-b9fb15e52e6d",
				"type": "DS",
				"selected": false,
				"source": "10e1557f-1baa-435d-96fe-4d704457a0ea",
				"sourcePort": "c4425a16-ad84-4b8e-af21-dd342ee8610d",
				"target": "eeb14611-f563-46af-ad92-ba52569aab9c",
				"targetPort": "00f8506a-77b8-40e1-9aca-ef37b8866deb",
				"points": [
				  {
					"id": "08d2f424-77a1-48c9-87ab-94813f03e438",
					"type": "point",
					"x": 361.65626816512713,
					"y": 395.10938827226335
				  },
				  {
					"id": "7b670329-ac2b-4978-8070-bc41257747bd",
					"type": "point",
					"x": 560.906248856222,
					"y": 427.1562645887796
				  }
				],
				"labels": [],
				"width": 3,
				"color": "normal",
				"curvyness": 50,
				"selectedColor": "rgb(0,192,255)"
			  }
			}
		  },
		  {
			"id": "fb68b6d4-7ab5-4015-962c-b4303f907cb7",
			"type": "diagram-nodes",
			"isSvg": false,
			"transformed": true,
			"models": {
			  "10e1557f-1baa-435d-96fe-4d704457a0ea": isDatabricks? sql : rdbms,
			  "eeb14611-f563-46af-ad92-ba52569aab9c": {
				"id": "eeb14611-f563-46af-ad92-ba52569aab9c",
				"locked": false,
				"type": "DS",
				"selected": false,
				"extras": {
				  "iconCls": "icon-class",
				  "fnName": "write.show_df",
				  "key": "Show",
				  "portManagement": {
					"inputPorts": {
					  "defaultValue": 1
					},
					"outputPorts": {
					  "defaultValue": 0
					}
				  },
				  "formData": [
					{
					  "key": "schema",
					  "type": "radio",
					  "defaultValue": "true",
					  "templateOptions": {
						"variable_type": "boolean",
						"label": "Show Dataframe Schema",
						"arg_index": 1,
						"qtip": "If Yes, Dataframe schema will be displayed",
						"inline": true,
						"options": [
						  {
							"label": "Yes",
							"value": "true"
						  },
						  {
							"label": "No",
							"value": "false"
						  }
						]
					  },
					  "isFieldHidden": false
					},
					{
					  "key": "records",
					  "type": "radio",
					  "defaultValue": "true",
					  "templateOptions": {
						"variable_type": "boolean",
						"label": "Show Dataframe Records",
						"arg_index": 2,
						"qtip": "If Yes, Dataframe records will be displayed",
						"inline": true,
						"options": [
						  {
							"label": "Yes",
							"value": "true"
						  },
						  {
							"label": "No",
							"value": "false"
						  }
						]
					  },
					  "isFieldHidden": false
					},
					{
					  "key": "num_rows",
					  "type": "input",
					  "defaultValue": "20",
					  "templateOptions": {
						"variable_type": "int",
						"label": "Number of Records",
						"arg_index": 3,
						"placeholder": "20",
						"qtip": "Number of Records to display"
					  },
					  "hideExpression": "values.records === 'false'",
					  "isFieldHidden": false
					},
					{
					  "key": "truncate",
					  "type": "radio",
					  "defaultValue": "true",
					  "templateOptions": {
						"variable_type": "boolean",
						"label": "Truncate Long String Values",
						"arg_index": 4,
						"qtip": "If Yes, column values with long strings will be truncated",
						"inline": true,
						"options": [
						  {
							"label": "Yes",
							"value": "true"
						  },
						  {
							"label": "No",
							"value": "false"
						  }
						]
					  },
					  "hideExpression": "values.records === 'false'",
					  "isFieldHidden": false
					},
					{
					  "key": "num_ip_ports",
					  "type": "input",
					  "value": 1,
					  "defaultValue": 0,
					  "templateOptions": {
						"label": "",
						"options": []
					  },
					  "hideExpression": "true",
					  "isFieldHidden": true
					},
					{
					  "key": "num_op_ports",
					  "type": "input",
					  "value": 0,
					  "defaultValue": 0,
					  "templateOptions": {
						"label": "",
						"options": []
					  },
					  "hideExpression": "true",
					  "isFieldHidden": true
					}
				  ],
				  "filePath": "/nodes/Data Transformation/Other/show.json",
				  "componentInfo": [
					{
					  "key": "description",
					  "defaultValue": "Show/print dataframe on Console."
					}
				  ],
				  "isReadOnly": false
				},
				"x": 558.9115407981043,
				"y": 393.16578847461557,
				"ports": [
				  {
					"id": "00f8506a-77b8-40e1-9aca-ef37b8866deb",
					"type": "DS",
					"selected": false,
					"x": 552.9062184300686,
					"y": 419.15625244757416,
					"name": "IN-0",
					"alignment": "left",
					"parentNode": "eeb14611-f563-46af-ad92-ba52569aab9c",
					"links": [
					  "30682bc5-2d83-4b2f-b77b-b9fb15e52e6d"
					],
					"isVariablePort": false
				  }
				],
				"title": "Show",
				"subtitle": "DataTransformation",
				"actualTitle": "Show",
				"iconKey": "DataTransformation/Other",
				"isPropertiesValid": true,
				"notes": "",
				"isPropertiesTouched": true,
				"isPropertiesSavedAtleastOnce": false,
				"nodeType": "component",
				"isMounted": true,
				"dfName": "show_6",
				"hash": "6b04f75699509a4d33ceb375b7ccec4d",
				"portsInOrder": [
				  "00f8506a-77b8-40e1-9aca-ef37b8866deb"
				],
				"portsOutOrder": []
			  }
			}
		  }
		],
		"workflowMetaData": {
		  "env": "spark",
		  "config": "[]",
		  "workflowDependenciesRef": {},
		  "workflowsInfo": {},
		  "workflowName": "test-de"
		}
	};
	return JSON.stringify(obj)
}

export const submitStatementDetails = (sessionId: string, database_name: string, query: string, cluster: string, isDatabricks?: boolean ) => {
	const rdbms = {
		"id": "10e1557f-1baa-435d-96fe-4d704457a0ea",
		"fn_id": "ReadRDBMS",
		"fnName": "read.read_from_rdbms",
		"title": "Read RDBMS",
		"inputPorts": [],
		"outputPorts": [
		  {
			"id": "c4425a16-ad84-4b8e-af21-dd342ee8610d",
			"type": "OUT-0",
			"link": [
			  "30682bc5-2d83-4b2f-b77b-b9fb15e52e6d"
			],
			"parentNode": "10e1557f-1baa-435d-96fe-4d704457a0ea"
		  }
		],
		"data": [
		  {
			"key": "connection_name",
			"value": database_name,
			"arg_index": 2,
			"variable_type": "string",
			"useKey": true
		  },
		  {
			"key": "p_type",
			"value": "Query",
			"arg_index": 3,
			"variable_type": "string",
			"useKey": true
		  },
		  {
			"key": "p_query",
			"value": query,
			"arg_index": 5,
			"remove_multiline": true,
			"variable_type": "string",
			"useKey": true
		  },
		  {
			"key": "p_partition",
			"value": "",
			"arg_index": 6,
			"variable_type": "string",
			"useKey": true
		  },
		  {
			"key": "p_fetchsize",
			"value": 50000,
			"arg_index": 10,
			"variable_type": "integer",
			"useKey": true
		  },
		  {
			"key": "sqlContext",
			"value": "sqlContext",
			"variable_type": "",
			"arg_index": 1
		  },
		  {
			"key": "p_table",
			"value": "",
			"arg_index": 4,
			"variable_type": "string",
			"useKey": true
		  },
		  {
			"key": "p_numpartitions",
			"value": 1,
			"arg_index": 7,
			"variable_type": "integer",
			"useKey": true
		  },
		  {
			"key": "p_lower",
			"value": 1,
			"arg_index": 8,
			"variable_type": "string",
			"useKey": true
		  },
		  {
			"key": "p_upper",
			"value": 1,
			"arg_index": 9,
			"variable_type": "string",
			"useKey": true
		  }
		],
		"type": "component",
		"df_name": "read_rdbms_0",
		"previewAllowed": true,
		"field_workflow_config_mapping": {},
		"field_var_mapping": [],
		"extraData": {}
	}
	const sql = {
		"id": "10e1557f-1baa-435d-96fe-4d704457a0ea",
		"fn_id": "sql_query",
		"fnName": "transform.sql_query",
		"title": "SQL Query",
		"inputPorts": [
			{
				"id": "2dc565e9-15cb-4145-a6fe-e9da3d8a5528",
				"type": "IN-0",
				"link": [],
				"parentNode": "6a6d9eef-f90a-4c31-a5cc-085a13eb9155"
			}
		],
		"outputPorts": [
			{
			  "id": "c4425a16-ad84-4b8e-af21-dd342ee8610d",
			  "type": "OUT-0",
			  "link": [
				"30682bc5-2d83-4b2f-b77b-b9fb15e52e6d"
			  ],
			  "parentNode": "10e1557f-1baa-435d-96fe-4d704457a0ea"
			}
		],
		"data": [
			{
				"key": "Query",
				"value": query,
				"arg_index": 2,
				"remove_multiline": true,
				"variable_type": "string"
			},
			{
				"key": "sqlContext",
				"value": "sqlContext",
				"variable_type": "",
				"arg_index": 1
			}
		],
		"type": "component",
		"df_name": "sql_query_2",
		"previewAllowed": true,
		"field_workflow_config_mapping": {},
		"field_var_mapping": [],
		"extraData": {},
		"append": true
	};
	return {
        "sessionId": sessionId,
        "payload": {
          "workflow_config": {},
          "nodes": [
            isDatabricks ? sql : rdbms,
            {
              "id": "eeb14611-f563-46af-ad92-ba52569aab9c",
              "fn_id": "Show",
              "fnName": "write.show_df",
              "title": "Show",
              "inputPorts": [
                {
                  "id": "00f8506a-77b8-40e1-9aca-ef37b8866deb",
                  "type": "IN-0",
                  "link": [
                    "30682bc5-2d83-4b2f-b77b-b9fb15e52e6d"
                  ],
                  "parentNode": "eeb14611-f563-46af-ad92-ba52569aab9c"
                }
              ],
              "outputPorts": [],
              "data": [
                {
                  "key": "schema",
                  "value": true,
                  "arg_index": 1,
                  "variable_type": "boolean"
                },
                {
                  "key": "records",
                  "value": true,
                  "arg_index": 2,
                  "variable_type": "boolean"
                },
                {
                  "key": "num_rows",
                  "value": "20",
                  "arg_index": 3,
                  "variable_type": "number"
                },
                {
                  "key": "truncate",
                  "value": true,
                  "arg_index": 4,
                  "variable_type": "boolean"
                }
              ],
              "type": "component",
              "df_name": "show_6",
              "previewAllowed": true,
              "field_workflow_config_mapping": {}
            }
          ],
          "links": [
            {
              "id": "30682bc5-2d83-4b2f-b77b-b9fb15e52e6d",
              "bridge": "Read RDBMS  <===>  Show",
              "source": {
                "node": "10e1557f-1baa-435d-96fe-4d704457a0ea",
                "port": "OUT-0"
              },
              "target": {
                "node": "eeb14611-f563-46af-ad92-ba52569aab9c",
                "port": "IN-0"
              }
            }
          ]
        },
        "env": "spark",
        "clusterId": cluster
    }
};

export const getTabInfoData = (sessionId: string, previewStatementId: string, dataExplorer: any, username: string) => {
	return {
		"name": "test-de",
		"details": "{\"id\":\"c1b85bb8-40bf-4e9d-82b4-a6e61a7c4128\",\"offsetX\":89.77895993885753,\"offsetY\":-67.31308382961022,\"zoom\":83.45000000000005,\"gridSize\":0,\"layers\":[{\"id\":\"b842ce35-eefa-441e-b6f9-02489f650f33\",\"type\":\"diagram-links\",\"isSvg\":true,\"transformed\":true,\"models\":{\"30682bc5-2d83-4b2f-b77b-b9fb15e52e6d\":{\"id\":\"30682bc5-2d83-4b2f-b77b-b9fb15e52e6d\",\"type\":\"DS\",\"selected\":false,\"source\":\"10e1557f-1baa-435d-96fe-4d704457a0ea\",\"sourcePort\":\"c4425a16-ad84-4b8e-af21-dd342ee8610d\",\"target\":\"eeb14611-f563-46af-ad92-ba52569aab9c\",\"targetPort\":\"00f8506a-77b8-40e1-9aca-ef37b8866deb\",\"points\":[{\"id\":\"08d2f424-77a1-48c9-87ab-94813f03e438\",\"type\":\"point\",\"x\":361.65626816512713,\"y\":395.10938827226335},{\"id\":\"7b670329-ac2b-4978-8070-bc41257747bd\",\"type\":\"point\",\"x\":560.906248856222,\"y\":427.1562645887796}],\"labels\":[],\"width\":3,\"color\":\"normal\",\"curvyness\":50,\"selectedColor\":\"rgb(0,192,255)\"}}},{\"id\":\"fb68b6d4-7ab5-4015-962c-b4303f907cb7\",\"type\":\"diagram-nodes\",\"isSvg\":false,\"transformed\":true,\"models\":{\"10e1557f-1baa-435d-96fe-4d704457a0ea\":{\"id\":\"10e1557f-1baa-435d-96fe-4d704457a0ea\",\"locked\":false,\"type\":\"DS\",\"selected\":false,\"extras\":{\"key\":\"ReadRDBMS\",\"fnName\":\"read.read_from_rdbms\",\"iconCls\":\"icon-class\",\"subheader\":[{\"field\":\"database\",\"property\":\"name\"},{\"field\":\"table\",\"property\":\"value\"}],\"portManagement\":{\"inputPorts\":{\"defaultValue\":0},\"outputPorts\":{\"defaultValue\":1}},\"formData\":[{\"key\":\"connection_name\",\"type\":\"select\",\"async\":{\"type\":\"GET\",\"url\":\"/databrowser/api/v1/datasource?connection_type=RDBMS\",\"init\":true,\"output\":\"url,username,password,driver,databaseName,name\",\"labelKey\":\"name\",\"valueKey\":\"id\",\"ignore_prefix_url\":true},\"templateOptions\":{\"variable_type\":\"number\",\"required\":true,\"label\":\"Select a Database\",\"arg_index\":2,\"qtip\":\"Select name of the database\",\"valueProp\":\"id\",\"labelProp\":\"name\",\"options\":[],\"useKey\":true},\"value\":11,\"isFieldHidden\":false},{\"key\":\"p_type\",\"type\":\"select\",\"defaultValue\":\"Table\",\"templateOptions\":{\"label\":\"Table/Query\",\"arg_index\":3,\"qtip\":\"Ingest data from a table or write custom SQL query\",\"variable_type\":\"string\",\"options\":[{\"label\":\"Table\",\"value\":\"Table\"},{\"label\":\"Query\",\"value\":\"Query\"}],\"useKey\":true},\"value\":\"Query\",\"isFieldHidden\":false},{\"key\":\"p_table\",\"type\":\"ng-select\",\"async\":{\"type\":\"GET\",\"url\":\"/databrowser/api/v1/datasource//tables?pattern=\",\"ignore_prefix_url\":true,\"triggerField\":\"values.connection_name\",\"searchable\":true,\"patternProperty\":\"pattern\",\"output\":\"label\",\"labelKey\":\"label\",\"valueKey\":\"label\"},\"templateOptions\":{\"variable_type\":\"string\",\"required\":true,\"label\":\"Select a Table\",\"arg_index\":4,\"qtip\":\"Select table from the specified database\",\"options\":[],\"useKey\":true},\"hideExpression\":\"values.p_type === 'Query'\",\"value\":\"\",\"isFieldHidden\":true},{\"key\":\"p_query\",\"type\":\"textarea\",\"editor\":true,\"templateOptions\":{\"advance_sql\":false,\"variable_type\":\"string\",\"remove_multiline\":true,\"required\":true,\"useKey\":true,\"qtip\":\"SQL query to select records from one or more tables\",\"label\":\"Query\",\"rows\":5,\"arg_index\":5},\"hideExpression\":\"values.p_type === 'Table'\",\"value\":\"SELECT * FROM build\",\"isFieldHidden\":false},{\"key\":\"p_partition\",\"type\":\"select\",\"async\":{\"type\":\"GET\",\"url\":\"/databrowser/api/v1/datasource//table//columns\",\"ignore_prefix_url\":true,\"triggerField\":\"values.p_table\",\"output\":\"label\",\"labelKey\":\"name\",\"valueKey\":\"name\"},\"templateOptions\":{\"variable_type\":\"string\",\"label\":\"Column to Partition By\",\"useKey\":true,\"qtip\":\"Select column to partition by while reading from the table\",\"options\":[],\"arg_index\":6},\"hideExpression\":\"values.p_type === 'Query'\",\"value\":\"\",\"isFieldHidden\":true},{\"key\":\"p_partition\",\"type\":\"input\",\"templateOptions\":{\"variable_type\":\"string\",\"label\":\"Column to Partition By\",\"useKey\":true,\"qtip\":\"Select column to partition by while reading from the table.The data type of partitioning column needs to be NUMERIC, DATE or TIMESTAMP\",\"options\":[],\"arg_index\":6},\"hideExpression\":\"values.p_type === 'Table'\",\"value\":\"\",\"isFieldHidden\":false},{\"key\":\"p_numpartitions\",\"type\":\"input\",\"defaultValue\":1,\"templateOptions\":{\"variable_type\":\"integer\",\"useKey\":true,\"label\":\"Number of Partitions\",\"qtip\":\"The maximum number of partitions that should be used for parallelization while reading the table\",\"max\":15,\"min\":1,\"arg_index\":7},\"hideExpression\":\"values.p_partition === ''\",\"value\":1,\"isFieldHidden\":true},{\"key\":\"p_lower\",\"type\":\"input\",\"defaultValue\":1,\"templateOptions\":{\"variable_type\":\"string\",\"useKey\":true,\"qtip\":\"Minimum value of the partitioned column.The lower bound can accept INT, DATE or Timestamp values\",\"label\":\"Lower Bound\",\"arg_index\":8},\"hideExpression\":\"values.p_partition === ''\",\"value\":1,\"isFieldHidden\":true},{\"key\":\"p_upper\",\"type\":\"input\",\"defaultValue\":1,\"templateOptions\":{\"variable_type\":\"string\",\"useKey\":true,\"qtip\":\"Maximum value of the partitioned column.The upper bound can accept INT, DATE or Timestamp values\",\"label\":\"Upper Bound\",\"arg_index\":9},\"hideExpression\":\"values.p_partition === ''\",\"value\":1,\"isFieldHidden\":true},{\"key\":\"p_fetchsize\",\"type\":\"input\",\"defaultValue\":50000,\"templateOptions\":{\"variable_type\":\"integer\",\"useKey\":true,\"label\":\"Fetch Size\",\"qtip\":\"Number of rows to fetch per iteration\",\"arg_index\":10},\"value\":50000,\"isFieldHidden\":false},{\"key\":\"num_ip_ports\",\"type\":\"input\",\"value\":0,\"defaultValue\":0,\"templateOptions\":{\"label\":\"\",\"options\":[]},\"hideExpression\":\"true\",\"isFieldHidden\":true},{\"key\":\"num_op_ports\",\"type\":\"input\",\"value\":1,\"defaultValue\":0,\"templateOptions\":{\"label\":\"\",\"options\":[]},\"hideExpression\":\"true\",\"isFieldHidden\":true}],\"filePath\":\"/nodes/Data Transformation/Relational Sources/read_rdbms.json\",\"componentInfo\":[{\"key\":\"description\",\"defaultValue\":\"Read RDBMS ingests data from relational tables. This component can read data from a specific table or execute an SQL query to select data from multiple tables.\"}],\"extraData\":{\"workflow_var_mapping\":{\"all_fields_list\":[]},\"workflow_config_mapping\":{\"selectedConfigKeys\":\"\",\"selectedFieldKeys\":[],\"keyFieldMapping\":{}},\"connection_name\":{\"_value\":11,\"url\":\"jdbc:mysql://10.2.0.226:3306/appmeta\",\"username\":\"root\",\"password\":\"\",\"driver\":\"com.mysql.jdbc.Driver\",\"databaseName\":\"appmeta\",\"name\":\"Madan_test\"},\"p_table\":null},\"isReadOnly\":false},\"x\":144.93699754296046,\"y\":361.11084043848956,\"ports\":[{\"id\":\"c4425a16-ad84-4b8e-af21-dd342ee8610d\",\"type\":\"DS\",\"selected\":false,\"x\":353.6563108787655,\"y\":387.1093944160059,\"name\":\"OUT-0\",\"alignment\":\"right\",\"parentNode\":\"10e1557f-1baa-435d-96fe-4d704457a0ea\",\"links\":[\"30682bc5-2d83-4b2f-b77b-b9fb15e52e6d\"],\"isVariablePort\":false}],\"title\":\"Read RDBMS\",\"subtitle\":\"DataTransformation\",\"actualTitle\":\"Read RDBMS\",\"iconKey\":\"DataTransformation/RelationalSources\",\"isPropertiesValid\":true,\"notes\":\"\",\"isPropertiesTouched\":true,\"isPropertiesSavedAtleastOnce\":true,\"nodeType\":\"component\",\"isMounted\":true,\"dfName\":\"read_rdbms_0\",\"hash\":\"4a9c51ae48c2b06b011e91cfb7a2a109\",\"portsInOrder\":[],\"portsOutOrder\":[\"c4425a16-ad84-4b8e-af21-dd342ee8610d\"]},\"eeb14611-f563-46af-ad92-ba52569aab9c\":{\"id\":\"eeb14611-f563-46af-ad92-ba52569aab9c\",\"locked\":false,\"type\":\"DS\",\"selected\":false,\"extras\":{\"iconCls\":\"icon-class\",\"fnName\":\"write.show_df\",\"key\":\"Show\",\"portManagement\":{\"inputPorts\":{\"defaultValue\":1},\"outputPorts\":{\"defaultValue\":0}},\"formData\":[{\"key\":\"schema\",\"type\":\"radio\",\"defaultValue\":\"true\",\"templateOptions\":{\"variable_type\":\"boolean\",\"label\":\"Show Dataframe Schema\",\"arg_index\":1,\"qtip\":\"If Yes, Dataframe schema will be displayed\",\"inline\":true,\"options\":[{\"label\":\"Yes\",\"value\":\"true\"},{\"label\":\"No\",\"value\":\"false\"}]},\"isFieldHidden\":false},{\"key\":\"records\",\"type\":\"radio\",\"defaultValue\":\"true\",\"templateOptions\":{\"variable_type\":\"boolean\",\"label\":\"Show Dataframe Records\",\"arg_index\":2,\"qtip\":\"If Yes, Dataframe records will be displayed\",\"inline\":true,\"options\":[{\"label\":\"Yes\",\"value\":\"true\"},{\"label\":\"No\",\"value\":\"false\"}]},\"isFieldHidden\":false},{\"key\":\"num_rows\",\"type\":\"input\",\"defaultValue\":\"20\",\"templateOptions\":{\"variable_type\":\"int\",\"label\":\"Number of Records\",\"arg_index\":3,\"placeholder\":\"20\",\"qtip\":\"Number of Records to display\"},\"hideExpression\":\"values.records === 'false'\",\"isFieldHidden\":false},{\"key\":\"truncate\",\"type\":\"radio\",\"defaultValue\":\"true\",\"templateOptions\":{\"variable_type\":\"boolean\",\"label\":\"Truncate Long String Values\",\"arg_index\":4,\"qtip\":\"If Yes, column values with long strings will be truncated\",\"inline\":true,\"options\":[{\"label\":\"Yes\",\"value\":\"true\"},{\"label\":\"No\",\"value\":\"false\"}]},\"hideExpression\":\"values.records === 'false'\",\"isFieldHidden\":false},{\"key\":\"num_ip_ports\",\"type\":\"input\",\"value\":1,\"defaultValue\":0,\"templateOptions\":{\"label\":\"\",\"options\":[]},\"hideExpression\":\"true\",\"isFieldHidden\":true},{\"key\":\"num_op_ports\",\"type\":\"input\",\"value\":0,\"defaultValue\":0,\"templateOptions\":{\"label\":\"\",\"options\":[]},\"hideExpression\":\"true\",\"isFieldHidden\":true}],\"filePath\":\"/nodes/Data Transformation/Other/show.json\",\"componentInfo\":[{\"key\":\"description\",\"defaultValue\":\"Show/print dataframe on Console.\"}],\"isReadOnly\":false},\"x\":558.9115407981043,\"y\":393.16578847461557,\"ports\":[{\"id\":\"00f8506a-77b8-40e1-9aca-ef37b8866deb\",\"type\":\"DS\",\"selected\":false,\"x\":552.9062184300686,\"y\":419.15625244757416,\"name\":\"IN-0\",\"alignment\":\"left\",\"parentNode\":\"eeb14611-f563-46af-ad92-ba52569aab9c\",\"links\":[\"30682bc5-2d83-4b2f-b77b-b9fb15e52e6d\"],\"isVariablePort\":false}],\"title\":\"Show\",\"subtitle\":\"DataTransformation\",\"actualTitle\":\"Show\",\"iconKey\":\"DataTransformation/Other\",\"isPropertiesValid\":true,\"notes\":\"\",\"isPropertiesTouched\":true,\"isPropertiesSavedAtleastOnce\":false,\"nodeType\":\"component\",\"isMounted\":true,\"dfName\":\"show_6\",\"hash\":\"6b04f75699509a4d33ceb375b7ccec4d\",\"portsInOrder\":[\"00f8506a-77b8-40e1-9aca-ef37b8866deb\"],\"portsOutOrder\":[]}}}],\"workflowMetaData\":{\"env\":\"spark\",\"config\":\"[]\",\"workflowDependenciesRef\":{},\"workflowsInfo\":{},\"workflowName\":\"test-de\"}}",
		"id": dataExplorer.id,
		"version": 1,
		"saved": true,
		"createdBy": username,
		"isStarred": false,
		"notes": "",
		"componentIdsOfPlots": [],
		"showPlotInProgressSpinner": true,
		"graphsInfo": {
			"layout": [],
			"refs": {},
			"data": {},
			"fullScreenInfo": null
		},
		"dfList": [],
		"previewStatementId": previewStatementId,
		"activeComponentIdForAnalytics": "10e1557f-1baa-435d-96fe-4d704457a0ea",
		"sessionId": sessionId,
		"isStreaming": false,
		"workflowPositionInList": 1,
		"isReadOnly": false,
		"isExecutable": true,
		"hasVariables": false,
		"componentCounter": 7,
		"zeppelinNotebookId": null,
		"directoryId": dataExplorer.directory,
		"env": ExecutionEnvModes.Spark,
		"zepplinData": [],
		"isPreviewSessionCreationInProgress": false,
		"sessionState": null,
		"created": "2023-03-07T16:27:40.000+0000",
		"updated": "2023-03-09T12:58:49.000+0000",
		"config": []
	}
}

export const getStatementData = (sessionId: string, database_name: string, sqlQuery: string, cluster: string, isDatabricks?: boolean) => {
	const rdbms = {
		"id": "10e1557f-1baa-435d-96fe-4d704457a0ea",
		"fn_id": "ReadRDBMS",
		"fnName": "read.read_from_rdbms",
		"title": "Read RDBMS",
		"inputPorts": [],
		"outputPorts": [
			{
				"id": "c4425a16-ad84-4b8e-af21-dd342ee8610d",
				"type": "OUT-0",
				"link": [
					"30682bc5-2d83-4b2f-b77b-b9fb15e52e6d"
				],
				"parentNode": "10e1557f-1baa-435d-96fe-4d704457a0ea"
			}
		],
		"data": [
			{
				"key": "connection_name",
				"value": database_name,
				"arg_index": 2,
				"variable_type": "string",
				"useKey": true
			},
			{
				"key": "p_type",
				"value": "Query",
				"arg_index": 3,
				"variable_type": "string",
				"useKey": true
			},
			{
				"key": "p_query",
				"value": sqlQuery,
				"arg_index": 5,
				"remove_multiline": true,
				"variable_type": "string",
				"useKey": true
			},
			{
				"key": "p_partition",
				"value": "",
				"arg_index": 6,
				"variable_type": "string",
				"useKey": true
			},
			{
				"key": "p_fetchsize",
				"value": 50000,
				"arg_index": 10,
				"variable_type": "integer",
				"useKey": true
			},
			{
				"key": "sqlContext",
				"value": "sqlContext",
				"variable_type": "",
				"arg_index": 1
			},
			{
				"key": "p_table",
				"value": "",
				"arg_index": 4,
				"variable_type": "string",
				"useKey": true
			},
			{
				"key": "p_numpartitions",
				"value": 1,
				"arg_index": 7,
				"variable_type": "integer",
				"useKey": true
			},
			{
				"key": "p_lower",
				"value": 1,
				"arg_index": 8,
				"variable_type": "string",
				"useKey": true
			},
			{
				"key": "p_upper",
				"value": 1,
				"arg_index": 9,
				"variable_type": "string",
				"useKey": true
			}
		],
		"type": "component",
		"df_name": "read_rdbms_0",
		"previewAllowed": true,
		"field_workflow_config_mapping": {},
		"field_var_mapping": [],
		"extraData": {}
	};
	
	return {
		"sessionId": sessionId,
		"payload": {
			"workflow_config": {},
			"nodes": [
				isDatabricks ? {} : rdbms,
				{
					"id": "eeb14611-f563-46af-ad92-ba52569aab9c",
					"fn_id": "Show",
					"fnName": "write.show_df",
					"title": "Show",
					"inputPorts": [
						{
							"id": "00f8506a-77b8-40e1-9aca-ef37b8866deb",
							"type": "IN-0",
							"link": [
								"30682bc5-2d83-4b2f-b77b-b9fb15e52e6d"
							],
							"parentNode": "eeb14611-f563-46af-ad92-ba52569aab9c"
						}
					],
					"outputPorts": [],
					"data": [
						{
							"key": "schema",
							"value": true,
							"arg_index": 1,
							"variable_type": "boolean"
						},
						{
							"key": "records",
							"value": true,
							"arg_index": 2,
							"variable_type": "boolean"
						},
						{
							"key": "num_rows",
							"value": "20",
							"arg_index": 3,
							"variable_type": "int"
						},
						{
							"key": "truncate",
							"value": true,
							"arg_index": 4,
							"variable_type": "boolean"
						}
					],
					"type": "component",
					"df_name": "show_6",
					"previewAllowed": true,
					"field_workflow_config_mapping": {}
				}
			],
			"links": [
				{
					"id": "30682bc5-2d83-4b2f-b77b-b9fb15e52e6d",
					"bridge": "Read RDBMS  <===>  Show",
					"source": {
						"node": "10e1557f-1baa-435d-96fe-4d704457a0ea",
						"port": "OUT-0"
					},
					"target": {
						"node": "eeb14611-f563-46af-ad92-ba52569aab9c",
						"port": "IN-0"
					}
				}
			]
		},
		"env": "spark",
		"clusterId": cluster
	}
}
